import { Spinner, StyledInput } from '@ui';
import { InfiniteScroll, InfiniteScrollRender } from 'components/InfiniteScroll';
import { NextLayout } from 'components/Layout';
import { SearchTile } from 'components/Search/SearchTile';
import { SearchWelcomeComponent } from 'components/Search/SearchWelcomeComponent';
import { SearchResult } from 'components/Search/types';
import { useDebounce } from 'hooks';
import { useSWRPagination } from 'hooks/useSWRPagination';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchPage() {
    const { t } = useTranslation('common');
    const { query: urlQuery } = useRouter();
    const [query, setQuery] = useState<string>();
    const debouncedQuery = useDebounce(setQuery, 500);
    const swr = useSWRPagination<SearchResult[]>(`search?query=${encodeURIComponent(query)}`);

    useEffect(() => debouncedQuery(decodeURIComponent(urlQuery.query?.[0] ?? '')), [urlQuery]);

    return (
        <NextLayout title={t('search.pageTitle')} spacing={1}>
            <div className="tw-container tw-mt-4">
                <div className="tw-my-4">
                    <StyledInput fullWidth onChange={(e) => setQuery(e.currentTarget.value)} value={query} />
                </div>
                <div className="tw-my-4" />
                <div className="tw-grid tw-grid-cols-1 tw-gap-8 lg:tw-grid-cols-3">
                    <InfiniteScroll
                        indicatorStyle={{ gridColumn: '1 / -1' }}
                        loader={
                            <div className="tw-flex tw-justify-center tw-p-8">
                                <Spinner size="lg" color="success" />
                            </div>
                        }
                        endingIndicator={
                            <div className="tw-flex tw-justify-center tw-p-8">
                                <small>{t('search.endOfResults')}</small>
                            </div>
                        }
                        swr={swr}
                    >
                        {({ flattenedData }: InfiniteScrollRender<SearchResult>) => (
                            <>
                                {flattenedData.length > 0 ? (
                                    flattenedData
                                        .slice(0, 200)
                                        .map((item) => <SearchTile key={`${item.id}_${item.type}`} item={item} />)
                                ) : (
                                    <SearchWelcomeComponent />
                                )}
                            </>
                        )}
                    </InfiniteScroll>
                </div>
            </div>
        </NextLayout>
    );
}
